import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WHY_CHOOSE } from "@/data/site";

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="relative py-24 md:py-40 bg-brand-brown text-white overflow-hidden">
      <div aria-hidden className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-brand-brown/20 blur-3xl" />
      <div aria-hidden className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-brand-gold/10 blur-3xl" />

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 relative">
        <div className="grid lg:grid-cols-12 gap-12 mb-16 md:mb-24">
          <div className="lg:col-span-5">
            <p className="eyebrow text-brand-gold mb-6">(03) — Why DigiDoot</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-medium">
              Made for founders who <span className="italic text-brand-gold">count what matters</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-white/70 text-lg leading-relaxed">
            We built DigiDoot because most agencies choose sides — either creative theatre or spreadsheet drudgery. We refuse that trade-off. Here&apos;s the standard we hold ourselves to.
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {WHY_CHOOSE.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`why-choose-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="bg-brand-brown p-8 md:p-10 hover:bg-brand-gold/60 transition-colors duration-500 group"
            >
              <div className="w-9 h-9 rounded-full border border-brand-gold/50 flex items-center justify-center mb-6 group-hover:bg-brand-gold group-hover:text-brand-charcoal transition-colors duration-500">
                <Check size={16} strokeWidth={2} />
              </div>
              <h3 className="font-display text-2xl leading-tight mb-3 font-medium">{w.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
